(function () {
  'use strict';

  var TOKEN_KEY = 'bbhubGiveawaySession';

  function node(tag, className, text) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (text != null) element.textContent = String(text);
    return element;
  }

  function append(parent) {
    for (var i = 1; i < arguments.length; i++) if (arguments[i]) parent.appendChild(arguments[i]);
    return parent;
  }

  function shotTime(seconds) {
    var value = Math.max(0, Math.floor(Number(seconds) || 0));
    return Math.floor(value / 60) + ':' + String(value % 60).padStart(2, '0');
  }

  function storage(method, value) {
    try { return method === 'get' ? localStorage.getItem(TOKEN_KEY) : localStorage.setItem(TOKEN_KEY, value); } catch (_) { return null; }
  }

  function boot(root) {
    var api = root.dataset.apiBase;
    var locale = root.dataset.locale;
    var t = JSON.parse(root.querySelector('[data-shots-labels]').textContent);
    var loading = root.querySelector('[data-shots-loading]');
    var failure = root.querySelector('[data-shots-error]');
    var content = root.querySelector('[data-shots-content]');
    var token = storage('get');
    var session = { discord: { connected: false } };
    var data = null;
    var busy = false;
    var notice = null;
    var player = null;
    var personal = null;
    var personalKey = null;

    function request(path, options) {
      var headers = { 'Content-Type': 'application/json' };
      if (token) headers.Authorization = 'Bearer ' + token;
      return fetch(api + path, Object.assign({ headers: headers, credentials: 'omit', cache: 'no-store' }, options))
        .then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (body) {
            if (!response.ok) throw new Error(body.error || t.error);
            return body;
          });
        });
    }

    function number(value) {
      return Number(value).toLocaleString(locale);
    }

    // Matches the theme's button markup so its loading spinner applies.
    function button(text, className, handler) {
      var element = node('button', 'btn ' + (className || ''));
      var spinner = node('span', 'loading-overlay__spinner hidden');
      spinner.setAttribute('aria-hidden', 'true');
      spinner.appendChild(node('span')).setAttribute('data-load', 'loading');
      append(element, spinner, node('span', '', text));
      element.type = 'button';
      if (handler) element.addEventListener('click', handler);
      return element;
    }

    function externalLink(text, href, className) {
      var element = node('a', className, text);
      element.href = href;
      element.target = '_blank';
      element.rel = 'noopener noreferrer';
      return element;
    }

    // Clones the theme's error/success message snippets rendered in the template.
    function status(text, isError) {
      var element = root.querySelector(isError ? '[data-shots-error-template]' : '[data-shots-success-template]')
        .content.firstElementChild.cloneNode(true);
      element.classList.add('best-shots__status');
      element.hidden = false;
      element.querySelector(isError ? '.product-form__error-message' : '.product-form__success-message').textContent = text;
      return element;
    }

    // Runs one API action at a time, showing progress on the clicked button and the outcome under `scope`.
    function run(trigger, scope, task) {
      if (busy) return;
      busy = true;
      notice = null;
      trigger.disabled = true;
      trigger.setAttribute('aria-busy', 'true');
      var spinner = trigger.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');
      task().then(function (text) {
        busy = false;
        notice = text ? { scope: scope, text: text } : null;
        return reload();
      }).catch(function (error) {
        busy = false;
        notice = { scope: scope, text: error.message || t.error, error: true };
        render();
      });
    }

    function connectDiscord(event) {
      run(event.currentTarget, 'account', function () {
        return request('/giveaways/discord/start', { method: 'POST', body: JSON.stringify({ returnTo: location.href }) })
          .then(function (result) { location.assign(result.url); return new Promise(function () {}); });
      });
    }

    function noticeFor(scope) {
      return notice && notice.scope === scope ? status(notice.text, notice.error) : null;
    }

    function playShot(shot) {
      if (!player) return;
      player.src = player.dataset.embed + '?autoplay=1&start=' + Math.max(0, Math.floor(shot.timestampSeconds || 0));
      player.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function videoId(url) {
      try {
        var id = new URL(url).searchParams.get('v');
        return /^[A-Za-z0-9_-]{11}$/.test(id || '') ? id : null;
      } catch (_) { return null; }
    }

    function heroPanel(episode) {
      var panel = node('section', 'best-shots__panel best-shots__hero');
      var label = { VOTING: t.voting, CLOSING: t.counting, RESULTS: t.results }[episode.status];
      append(panel,
        node('p', 'best-shots__pill is-' + episode.status.toLowerCase(), label),
        node('h2', 'h2-style best-shots__title', episode.title));
      var meta = node('p', 'best-shots__meta');
      if (episode.status === 'VOTING' && episode.scheduledCloseAt) {
        meta.textContent = t.closesAt + ': ' + new Date(episode.scheduledCloseAt).toLocaleString(locale, { dateStyle: 'medium', timeStyle: 'short' });
      } else if (episode.status === 'RESULTS') {
        meta.textContent = episode.totalVotes ? number(episode.totalVotes) + ' ' + t.votes : t.noVotes;
      }
      if (meta.textContent) panel.appendChild(meta);

      var id = episode.youtubeUrl && videoId(episode.youtubeUrl);
      if (id) {
        var frame = node('div', 'best-shots__video');
        player = node('iframe');
        player.dataset.embed = 'https://www.youtube-nocookie.com/embed/' + id;
        player.src = player.dataset.embed;
        player.title = t.video;
        player.loading = 'lazy';
        player.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        player.allowFullscreen = true;
        panel.appendChild(append(frame, player));
      } else {
        player = null;
      }
      shotsList(episode, panel);
      return panel;
    }

    function shotsList(episode, panel) {
      var voting = episode.status === 'VOTING';
      var results = episode.status === 'RESULTS';
      if (voting) {
        panel.appendChild(node('p', 'best-shots__hint', session.discord.connected ? t.changeHint : t.connectToVote));
        if (!session.discord.connected) panel.appendChild(button(t.connectDiscord, 'best-shots__cta', connectDiscord));
      }
      append(panel, noticeFor('vote'));

      var maxVotes = 0;
      var shots = episode.shots.slice();
      if (results) {
        shots.forEach(function (shot) { maxVotes = Math.max(maxVotes, shot.votes || 0); });
        shots.sort(function (a, b) { return (a.place || 99) - (b.place || 99) || a.position - b.position; });
      }

      var grid = node('ol', 'best-shots__grid');
      shots.forEach(function (shot) {
        var mine = episode.myVoteSelectionId === shot.id;
        var card = node('li', 'best-shots__shot' + (mine ? ' is-mine' : '') + (shot.awarded ? ' is-winner' : ''));
        var badge = node('span', 'best-shots__number' + (results && shot.place && shot.place <= 3 ? ' is-place-' + shot.place : ''),
          results && shot.place ? shot.place : shot.position);
        badge.setAttribute('aria-hidden', 'true');
        var copy = node('div', 'best-shots__shot-copy');
        append(copy,
          node('strong', 'best-shots__player', shot.playerName),
          shot.playerId ? node('span', 'best-shots__muted', t.playerId + ': ' + shot.playerId) : null);
        if (shot.awarded) copy.appendChild(node('span', 'best-shots__tag', t.winner));
        if (mine) copy.appendChild(node('span', 'best-shots__tag', '✓ ' + t.yourVote));
        append(card, badge, copy);

        if (results) {
          var share = maxVotes ? Math.round((shot.votes / maxVotes) * 100) : 0;
          var bar = node('div', 'best-shots__bar');
          bar.style.setProperty('--share', share + '%');
          append(card, append(node('div', 'best-shots__votes'), bar, node('span', '', number(shot.votes || 0) + ' ' + t.votes)));
        }

        var actions = node('div', 'best-shots__shot-actions');
        if (player) {
          var play = button('▶ ' + shotTime(shot.timestampSeconds), 'btn--sm btn--grey', function () { playShot(shot); });
          play.setAttribute('aria-label', t.play + ' #' + shot.position + ' · ' + shotTime(shot.timestampSeconds));
          actions.appendChild(play);
        } else if (shot.videoUrl) {
          actions.appendChild(externalLink('▶ ' + shotTime(shot.timestampSeconds), shot.videoUrl, 'btn btn--sm btn--grey'));
        }
        if (voting && !mine) {
          actions.appendChild(button(t.vote, 'btn--sm', session.discord.connected ? function (event) {
            run(event.currentTarget, 'vote', function () {
              return request('/shots/vote', { method: 'POST', body: JSON.stringify({ episodeId: episode.id, selectionId: shot.id }) })
                .then(function () { return t.voteSaved; });
            });
          } : connectDiscord));
        }
        if (actions.childNodes.length) card.appendChild(actions);

        if (results && shot.awarded && shot.awardOptions.length) {
          var chosen = shot.awardOptions.filter(function (option) { return option.id === shot.chosenOptionId; });
          (chosen.length ? chosen : shot.awardOptions).forEach(function (option) {
            card.appendChild(node('p', 'best-shots__reward', option.label + ': ' + option.rewards.map(function (item) {
              return number(item.amount) + ' ' + item.name + (item.baseFallback ? ' (' + t.base + ')' : '');
            }).join(' + ')));
          });
        }
        grid.appendChild(card);
      });
      panel.appendChild(grid);
    }

    // Amounts at the signed-in player's VIP level; fetched once per linked ID and prize list.
    function loadPersonalPrizes(prizes) {
      if (!data.identity || !prizes || !prizes.length) {
        personal = personalKey = null;
        return;
      }
      var key = data.identity.playerId + '|' + prizes.map(function (option) { return option.id; }).join(',');
      if (key === personalKey) return;
      personalKey = key;
      personal = null;
      request('/shots/prizes').then(function (result) {
        if (key !== personalKey || !result.prizes) return;
        personal = { vipTier: result.vipTier, byId: {} };
        result.prizes.forEach(function (option) { personal.byId[option.id] = option.rewards; });
        render();
      }).catch(function () { /* Base amounts stay on show. */ });
    }

    // The live episode's prizes, or the next episode's when staff announce them before voting.
    function prizePanel(prizes) {
      if (!prizes || !prizes.length) return null;
      var panel = node('section', 'best-shots__panel');
      panel.appendChild(node('h3', 'h3-style', t.prizes));
      var places = {};
      prizes.forEach(function (option) { (places[option.place] = places[option.place] || []).push(option); });
      var list = node('div', 'best-shots__prizes');
      Object.keys(places).sort().forEach(function (place) {
        var options = places[place];
        var card = node('div', 'best-shots__prize is-place-' + place);
        append(card,
          node('span', 'best-shots__number is-place-' + place, place),
          node('strong', 'best-shots__prize-title', t.place + ' ' + place),
          options.length > 1 ? node('span', 'best-shots__muted', t.chooseOne) : null);
        var choices = node('ul', 'best-shots__choices');
        options.forEach(function (option, index) {
          var item = node('li');
          if (index) item.appendChild(node('span', 'best-shots__or', t.or));
          var mine = personal && personal.byId[option.id];
          option.rewards.forEach(function (reward, rewardIndex) {
            var own = mine && mine[rewardIndex];
            var line = node('span', 'best-shots__reward-line');
            if (reward.imageUrl) {
              var image = node('img');
              image.src = reward.imageUrl;
              image.alt = '';
              image.loading = 'lazy';
              image.width = 40;
              image.height = 40;
              image.onerror = function () { image.remove(); };
              line.appendChild(image);
            }
            var personalVip = own && own.source === 'VIP';
            append(line,
              node('strong', '', number(own ? own.amount : reward.baseAmount) + ' ' + reward.name),
              reward.calculation === 'FIXED' ? null
                : node('span', 'best-shots__muted', personalVip && personal.vipTier ? personal.vipTier + ' VIP' : t.vip));
            item.appendChild(line);
          });
          choices.appendChild(item);
        });
        list.appendChild(append(card, choices));
      });
      panel.appendChild(list);
      return panel;
    }

    function step(done, title, body) {
      var item = node('li', 'best-shots__step' + (done ? ' is-done' : ''));
      var mark = node('span', 'best-shots__step-mark', done ? '✓' : '');
      mark.setAttribute('aria-hidden', 'true');
      return append(item, mark, append(node('div', 'best-shots__step-body'), node('strong', '', title), body));
    }

    function idForm(current) {
      var form = node('form', 'best-shots__id-form');
      var label = node('label', 'visually-hidden', t.playerId);
      var input = node('input', 'form-control form-control--rounded');
      var invalid = status(t.idError, true);
      input.id = label.htmlFor = 'best-shots-id';
      input.inputMode = 'numeric';
      input.maxLength = 20;
      input.autocomplete = 'off';
      input.required = true;
      input.placeholder = current || t.playerId;
      invalid.hidden = true;
      var save = button(t.saveId, 'btn--sm');
      save.type = 'submit';
      input.addEventListener('input', function () { invalid.hidden = true; input.removeAttribute('aria-invalid'); });
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var id = input.value.trim();
        if (!/^\d{1,20}$/.test(id)) {
          invalid.hidden = false;
          input.setAttribute('aria-invalid', 'true');
          input.focus();
          return;
        }
        run(save, 'account', function () {
          return request('/shots/identity', { method: 'POST', body: JSON.stringify({ playerId: id }) })
            .then(function () { personalKey = null; return t.idLinked; });
        });
      });
      return append(form, label, input, save, invalid);
    }

    // Each rule is "Short title::Details".
    function rulesList() {
      var list = node('ol', 'best-shots__rules');
      (t.rules || []).forEach(function (rule) {
        var parts = rule.split('::');
        list.appendChild(append(node('li'),
          parts[1] ? node('strong', '', parts[0]) : null,
          parts[1] ? document.createTextNode(' ') : null,
          node('span', '', parts[1] || parts[0])));
      });
      return append(node('div', 'best-shots__rules-wrap'), node('h4', 'best-shots__rules-title', t.rulesTitle), list);
    }

    function accountPanel() {
      var panel = node('section', 'best-shots__panel');
      var connected = session.discord.connected;
      var identity = data.identity;
      append(panel, node('h3', 'h3-style', t.submitTitle), rulesList());
      var steps = node('ol', 'best-shots__steps');

      steps.appendChild(step(connected, t.stepDiscord, connected
        ? node('span', 'best-shots__muted', t.connectedAs + ' ' + (session.discord.username || 'Discord'))
        : button(t.connectDiscord, 'btn--sm', connectDiscord)));

      var idBody = node('div');
      if (!connected) idBody.appendChild(node('span', 'best-shots__muted', t.idHint));
      else if (identity) {
        var change = node('button', 'btn-link best-shots__link', t.change);
        change.type = 'button';
        change.addEventListener('click', function () {
          idBody.replaceChildren(idForm(identity.playerId));
          idBody.querySelector('input').focus();
        });
        append(idBody, node('span', 'best-shots__muted', t.idLinked + ': ' + identity.playerId + ' '), change);
      } else {
        append(idBody, node('span', 'best-shots__muted', t.idHint), idForm());
      }
      steps.appendChild(step(Boolean(connected && identity), t.stepId, idBody));
      steps.appendChild(step(false, t.stepPost, externalLink(t.openChannel, data.channelUrl, 'btn btn--sm btn--grey')));
      append(panel, steps, noticeFor('account'));
      return panel;
    }

    function render() {
      var stack = node('div', 'best-shots__stack');
      var episode = data.episode;
      loadPersonalPrizes(episode ? episode.prizes : data.upcomingPrizes);
      if (episode) {
        append(stack, heroPanel(episode), prizePanel(episode.prizes), accountPanel());
      } else {
        player = null;
        var empty = node('section', 'best-shots__panel best-shots__hero');
        append(empty, node('p', 'best-shots__pill', t.nextEpisode), node('h2', 'h2-style best-shots__title', t.title), node('p', 'best-shots__meta', t.noEpisode));
        append(stack, empty, prizePanel(data.upcomingPrizes), accountPanel());
      }
      content.replaceChildren(stack);
      content.hidden = false;
      loading.hidden = true;
      failure.hidden = true;
    }

    function reload() {
      return request('/shots').then(function (result) {
        // Keep the playing video when only votes or the account changed.
        var embed = player && data && data.episode && result.episode && data.episode.youtubeUrl === result.episode.youtubeUrl ? player : null;
        data = result;
        render();
        if (embed && player) {
          player.replaceWith(embed);
          player = embed;
        }
      });
    }

    function start() {
      loading.hidden = false;
      failure.hidden = true;
      request('/giveaways/session', { method: 'POST' }).then(function (result) {
        if (result.sessionToken) { token = result.sessionToken; storage('set', token); }
        session = result;
        return reload();
      }).catch(function (error) {
        console.error('Best Shots failed to load', error);
        loading.hidden = true;
        content.hidden = true;
        failure.hidden = false;
      });
    }

    var connection = new URLSearchParams(location.search).get('giveaway_connection');
    if (connection) {
      notice = connection === 'discord-connected'
        ? { scope: 'account', text: t.discordConnected }
        : { scope: 'account', text: t.discordError, error: true };
      var clean = new URL(location.href);
      clean.searchParams.delete('giveaway_connection');
      history.replaceState(history.state, '', clean.toString());
    }

    root.querySelector('[data-shots-retry]').addEventListener('click', start);
    start();
  }

  document.querySelectorAll('[data-best-shots]').forEach(boot);
})();
